<div class="nes-flex nes-flex-col">
  <nes-heading tag="h3" size="base" class="nes-mb-3" style="font-size: 20px;">
    {{ "RECEIPT.USP_BLOCK.TITLE" | translate }}
  </nes-heading>
  <nes-text-list
    list-type="checked"
    size="base"
    color="text-body"
  >
    <nes-text-list-item *ngFor="let item of items$ | async">{{ item }}</nes-text-list-item>
  </nes-text-list>
</div>
